import { Box } from "@mui/material";
import { Assignment } from "@mui/icons-material";

const EmptyPlaceHolderGuest = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      textAlign="center"
      sx={{ color: "text.secondary" }}
    >
      <Assignment
        sx={{
          fontSize: "4rem",
          mb: 2,
          opacity: 0.3,
        }}
      />
      <Box sx={{ fontSize: "1.25rem", fontWeight: 500, mb: 1 }}>
        No Questionnaire Found
      </Box>
      <Box sx={{ fontSize: "0.875rem", maxWidth: "300px" }}>
        There are currently no questionnaires available. Please check back later
        or contact support.
      </Box>
    </Box>
  );
};

export default EmptyPlaceHolderGuest;
